import { createContext } from 'react';

export const CompanyContext = createContext('di-gallo');
export const ConfigContext = createContext('');
export const LangContext = createContext('');
export const ConfigLoadedContext = createContext(false);
export const SeoContext = createContext({});